import PropTypes from "prop-types";
import { SuiModal } from "../../common/suiModal";
import { walmartMXTranslations as t } from "../../../translations/walmartMXTranslations";

const BrandLiftPreSaveModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <SuiModal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={t.brandLiftPreSaveTitle}
      modalContent={<p>{t.brandLiftPreSaveWarning}</p>}
      modalButtons={[
        {
          text: t.brandLiftPreSaveCancelBtn,
          onClick: onClose,
        },
        {
          text: t.brandLiftPreSaveConfirmBtn,
          color: "primary",
          onClick: onConfirm,
        },
      ]}
    />
  );
};

BrandLiftPreSaveModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default BrandLiftPreSaveModal;
